import { useMutation, useQuery } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { authHeaders, http } from './http.js';

async function listPayments(getToken, companyId, executionId, page, size) {
    const headers = await authHeaders(getToken);
    const { data } = await http.get(`/company/${companyId}/payment/execution/${executionId}`, {
        headers,
        params: { page, size },
    });
    return data;
}

function extractFilename(contentDisposition, fallback) {
    if (!contentDisposition) return fallback;
    const match = contentDisposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
    return match ? decodeURIComponent(match[1]) : fallback;
}

async function downloadPayments(getToken, companyId, executionId) {
    const headers = await authHeaders(getToken);
    const response = await http.get(`/company/${companyId}/payment/execution/${executionId}/download`, {
        headers,
        responseType: 'blob',
    });
    const filename = extractFilename(response.headers['content-disposition'], `payments_${executionId}.csv`);
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}

export function usePayments(companyId, executionId, page, size) {
    const { getToken } = useAuth();
    return useQuery({
        queryKey: ['payments', companyId, executionId, page, size],
        queryFn: () => listPayments(getToken, companyId, executionId, page, size),
        enabled: Boolean(companyId && executionId),
        placeholderData: (previousData) => previousData,
    });
}

export function useDownloadPayments(companyId, executionId) {
    const { getToken } = useAuth();
    return useMutation({
        mutationFn: () => downloadPayments(getToken, companyId, executionId),
    });
}